import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Collection from "@/pages/Collection";
import Gallery from "@/pages/Gallery";
import Submit from "@/pages/Submit";
import About from "@/pages/About";
import Sponsorship from "@/pages/Sponsorship";
import Chronicle from "@/pages/Chronicle";
import ChroniclePost from "@/pages/ChroniclePost";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Wholesale from "@/pages/Wholesale";
import FAQ from "@/pages/FAQ";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import PersonalisationSharePreview from "@/pages/PersonalisationSharePreview";
import NotFound from "@/pages/NotFound";
import CookieBanner from "@/components/CookieBanner";
import { CartProvider } from "@/lib/cart";

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <div className="App font-body">
          <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/new" element={<Shop filterNew />} />
            <Route path="/shop/:id" element={<Product />} />
            <Route path="/collections/:handle" element={<Collection />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/submit" element={<Submit />} />
            <Route path="/about" element={<About />} />
            <Route path="/sponsorship" element={<Sponsorship />} />
            <Route path="/chronicle" element={<Chronicle />} />
            <Route path="/chronicle/:slug" element={<ChroniclePost />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/:slug" element={<CampaignDetail />} />
            <Route path="/wholesale" element={<Wholesale />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/preview/:sessionId" element={<PersonalisationSharePreview />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#F9F9F4",
            color: "#0F0F0F",
            border: "2px solid #1A3626",
            borderRadius: 0,
            fontFamily: "Work Sans, sans-serif",
            fontWeight: 600,
          },
        }}
      />
      <CookieBanner />
        </div>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
